import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import {
  AnalyticsFilters,
  CampaignResponse,
  GenderResponse,
  GroupResponse,
  LineResponse,
  OverviewResponse,
  ProgramResponse,
  TimelineResponse,
} from '@core/interfaces/analytics.interface';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({ providedIn: 'root' })
export class AnalyticsService {
  private url = `${environment.base_url}/analytics`;

  constructor(private http: HttpClient) {}

  private getHeaders(): HttpHeaders {
    return new HttpHeaders()
      .set('Content-Type', 'application/json')
      .set('Authorization', `Bearer ${localStorage.getItem('token_conhector')}`)
      .set('iduser', `${localStorage.getItem('user_conhector')}`);
  }

  private buildParams(filters: AnalyticsFilters): HttpParams {
    let params = new HttpParams();
    if (filters.line) params = params.set('line', filters.line);
    if (filters.group) params = params.set('group', filters.group);
    if (filters.from) params = params.set('from', filters.from);
    if (filters.to) params = params.set('to', filters.to);
    if (filters.granularity)
      params = params.set('granularity', filters.granularity);
    return params;
  }

  getOverview(filters: AnalyticsFilters = {}): Observable<OverviewResponse> {
    return this.http.get<OverviewResponse>(`${this.url}/overview`, {
      headers: this.getHeaders(),
      params: this.buildParams(filters),
    });
  }

  getParticipantsByGender(
    filters: AnalyticsFilters = {},
  ): Observable<GenderResponse> {
    return this.http.get<GenderResponse>(`${this.url}/participants/gender`, {
      headers: this.getHeaders(),
      params: this.buildParams(filters),
    });
  }

  getParticipantsByLine(
    filters: AnalyticsFilters = {},
  ): Observable<LineResponse> {
    return this.http.get<LineResponse>(`${this.url}/participants/by-line`, {
      headers: this.getHeaders(),
      params: this.buildParams(filters),
    });
  }

  getParticipantsByGroup(
    filters: AnalyticsFilters = {},
  ): Observable<GroupResponse> {
    return this.http.get<GroupResponse>(`${this.url}/participants/by-group`, {
      headers: this.getHeaders(),
      params: this.buildParams(filters),
    });
  }

  getRegistrationTimeline(
    filters: AnalyticsFilters = {},
  ): Observable<TimelineResponse> {
    return this.http.get<TimelineResponse>(
      `${this.url}/participants/timeline`,
      {
        headers: this.getHeaders(),
        params: this.buildParams(filters),
      },
    );
  }

  getConversationTimeline(
    filters: AnalyticsFilters = {},
  ): Observable<TimelineResponse> {
    return this.http.get<TimelineResponse>(
      `${this.url}/conversations/timeline`,
      {
        headers: this.getHeaders(),
        params: this.buildParams(filters),
      },
    );
  }

  getConversationsByProgram(
    filters: AnalyticsFilters = {},
  ): Observable<ProgramResponse> {
    return this.http.get<ProgramResponse>(
      `${this.url}/conversations/by-program`,
      {
        headers: this.getHeaders(),
        params: this.buildParams(filters),
      },
    );
  }

  getCampaignStats(): Observable<CampaignResponse> {
    return this.http.get<CampaignResponse>(`${this.url}/campaigns`, {
      headers: this.getHeaders(),
    });
  }
}
